import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import ProductHalfHero from "../../../../V2/Heroes/Product/HalfHero"

import {
  useGetEcoSystemObjectFields,
  useGetPurchasableItem,
} from "@hooks/V2/storyblok"
import { getUrlFromStoryblokLink, linkIsNotNull } from "@utils/storyblok"

const StoryblokProductHalfHero = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ProductHalfHero>) => {
  const getEcoSystemObjectFields = useGetEcoSystemObjectFields()
  const getPurchasableItem = useGetPurchasableItem()

  const ecoSystemFields = getEcoSystemObjectFields(blok.productConfig)
  const purchasableItem = getPurchasableItem(
    blok.productConfig.uuid,
    blok.productConfig.content
  )

  return (
    <ProductHalfHero
      backgroundColor={blok.backgroundColor}
      primaryButtonBorderColor={blok.primaryCTAColor}
      bodyText={blok.bodyText}
      headingText={blok.headingText}
      headingSize={blok.headingSize}
      headingMobileAlignment={blok.headingMobileAlignment}
      imageAlt={blok.image.alt}
      imageUrl={blok.image.filename}
      primaryButtonLink={
        blok.primaryCTALink && linkIsNotNull(blok.primaryCTALink)
          ? getUrlFromStoryblokLink(blok.primaryCTALink)
          : undefined
      }
      primaryButtonMobileLink={
        blok.primaryCTAMobileLink && linkIsNotNull(blok.primaryCTAMobileLink)
          ? getUrlFromStoryblokLink(blok.primaryCTAMobileLink)
          : ""
      }
      primaryButtonText={blok.primaryCTAText}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      secondaryButtonLink={getUrlFromStoryblokLink(blok.secondaryCTALink)}
      secondaryButtonText={blok.secondaryCTAText}
      iconUrl={blok.footerIcon?.filename}
      priceValue={ecoSystemFields.price}
      priceSidescriptText={ecoSystemFields.priceSideScript}
      priceSuperscriptText={
        ecoSystemFields.onPromotion
          ? `Was R${ecoSystemFields.originalPrice}`
          : undefined
      }
      priceSubscriptText={ecoSystemFields.priceSubScript}
      callout={blok.callout ? blok.callout[0] : undefined}
      purchasableItem={purchasableItem}
      isPurchasable={blok.isPurchasable}
      reasonNotAvailable={ecoSystemFields.reasonNotAvailable}
      waitlistLink={ecoSystemFields.waitlistLink}
      hasScrollArrow={blok.hasScrollArrow}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokProductHalfHero
